var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['jp-alert', 'text8', _vm.variant && `alert--${_vm.variant}`]},[_c('FontIcon',{class:[_vm.variant, 'text5'],attrs:{"name":_vm.fontIconName(_vm.variant)}}),_c('span',{staticClass:"alert-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }